import React from "react";

import AboutPart from './AboutSection'
import Feature from './FeatureSection'

const AboutMain = () => {


    return (
        <>
            <AboutPart />

            <Feature />
        </>
    )
}

export default AboutMain;